export const getLoading = (state: any) => state.loader.loading;
